import { Card } from 'react-bootstrap';

const BenefitCard = ({ title, description }) => {
    return (
        <Card className="benefit-card h-100 p-2">
            <Card.Body className='p-2'>
                <div className="d-flex align-items-center gap-3 mb-2">
                    <div className="benefit-icon flex-shrink-0" aria-hidden="true">
                        <svg viewBox="0 0 24 24" role="img" focusable="false">
                            <path
                                d="M9.5 16.5L5.5 12.5L6.9 11.1L9.5 13.7L17.1 6.1L18.5 7.5L9.5 16.5Z"
                                fill="currentColor"
                            />
                        </svg>
                    </div>
                    <h5 className='fw-semibold fs-6 mb-0'>{title}</h5>
                </div>
                <Card.Text className="mb-0">{description}</Card.Text>
            </Card.Body>
        </Card>
    );
};
export default BenefitCard;
